import React from 'react';
import classnames from 'classnames';

import './style.scss';

const PREFIX = 'music';

export interface ChipsProps {
  /** 标签文本 */
  children: React.ReactNode;
  /** 是否选中 */
  selected?: boolean;
  /** 自定义类名 */
  className?: string;
  /** 点击回调 */
  onClick?: () => void;
}

export default function Chips({ children, selected = false, className, onClick }: ChipsProps) {
  return (
    <button
      type="button"
      className={classnames(
        `${PREFIX}-chips`,
        { [`${PREFIX}-chips--selected`]: selected },
        className
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export interface ChipsGroupProps {
  /** 选项列表 */
  options: Array<{ label: string; value: string }>;
  /** 当前选中值 */
  value?: string;
  /** 选择回调 */
  onChange?: (value: string) => void;
  /** 自定义类名 */
  className?: string;
}

export function ChipsGroup({ options, value, onChange, className }: ChipsGroupProps) {
  return (
    <div className={classnames(`${PREFIX}-chips-group`, className)}>
      {options.map((option) => (
        <Chips
          key={option.value}
          selected={value === option.value}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </Chips>
      ))}
    </div>
  );
}
